import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWorldPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.161 6.586a5.27 5.27 0 0 0-1.102-2.834 5.2 5.2 0 0 0-2.481-1.743 5.2 5.2 0 0 0-3.026-.065c-.992.28-1.88.848-2.552 1.635a5.277 5.277 0 0 0-.702 5.783 5.24 5.24 0 0 0 2.086 2.205 5.2 5.2 0 0 0 2.951.67M2.088 5.25h9.742M2.088 8.75h5.161"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.669 1.75a9.96 9.96 0 0 0 0 10.5M7.249 1.75a9.95 9.95 0 0 1 1.495 5.26M12.247 11.738a1.75 1.75 0 0 0 .377-1.908 1.732 1.732 0 0 0-3.215 0 1.76 1.76 0 0 0 .378 1.908q.363.366 1.23 1.096.915-.779 1.23-1.096M11.019 10.5v.007"
    />
  </svg>
);
export default SvgWorldPinIcon;
